
<div>
  <checkmark-list v-if="specialNeedsRecipientAgeGroups" :tips="specialNeedsAgeDisplay" />
  <tag-label-group
    v-if="specialNeedsCareExperience"
    :items="specialNeedsCareDisplay"
    title="Types of special needs experience"
    class="mt-16"
  />
  <tag-label-group
    v-if="specialNeedsConditionExperience"
    :items="specialNeedsConditionDisplay"
    title="Special needs conditions experience"
    class="mt-16"
  />
  <tag-label-group
    v-if="specialNeedsServiceExperience"
    :items="specialNeedsServiceDisplay"
    title="Special needs services experience"
    class="mt-16"
  />
</div>
